module.exports = __webpack_public_path__ + "static/media/new-york-18.9fd3c1ec.jpg";